import React from 'react';
import CtaForm from './CtaForm';

const CtafromSection = (props) => {
    return (
        <section className={"" +props.hclass}>
            <div className="container">
                <div className="cta_wrap">
                    <div className="content">
                        <h2>Book Your Consultation</h2>
                        <p>We&apos;re here to guide you. Reach out anytime and let&apos;s find what works best for you.</p>
                    </div>
                    <CtaForm/>
                </div>
            </div>
        </section>
    );
};

export default CtafromSection;